<template>
  <DefaultBackground>
    <section v-if="ep" class="m-2 md:m-10">
      <div class="container mx-auto">
        <div class="grid grid-cols-12 gap-6 mx-auto">
          <div class="col-span-12 lg:col-span-8 xl:col-span-9">

            <div v-if="ep.status == 'pending'" class="bg-yellow-500 rounded-lg shadow-card mx-auto mb-6 p-4  text-semibold">
              This Account is Under Review and Will Be Active Upon Verification
            </div>

            <!-- MENU -->
            <div class="bg-white rounded-lg shadow-card mx-auto mb-6">
              <header class="flex flex-col md:flex-row justify-between items-center px-6 py-4">
                <h2 class="font-semibold text-2xl lg:text-2xl py-2">
                  Products and Services
                </h2>

                <a
                  v-if="canMakeOrder"
                  @click="$router.push(`/event-planners/${ep.uuid}/order`)"
                  class="btn btn-secondary font-semibold rounded-lg px-4"
                  >Plan an Event with this Caterer</a
                >
              </header>

              <div v-if="categories && categories.length > 0">
                <div v-for="(category, index) in categories" :key="category.uuid"
                     :class="{'border-b border-gray-300': index < categories.length - 1}"
                     class="px-3 py-5">
                  <div class="flex flex-row items-center px-2 md:px-4 group">
                    <div
                      class="w-12 h-12 rounded bg-gray-600 overflow-hidden flex items-center justify-center flex-shrink-0">
                      <img :src="category.image" alt="Order Details Page" />
                    </div>
                    <div class="ml-4 min-w-0">
                      <div class="flex items-center">
                        <div class="font-semibold text-primary">
                          {{ category.name }}
                        </div>
                      </div>
                      <div class="text-gray-600 mt-1">{{ category.description }}</div>
                    </div>
                  </div>
                  <div class="mt-4 md:ml-10">
                    <div v-if="category.items && category.items.length > 0" class="">
                      <div v-for="item in category.items" :key="item.uuid" class="line-item">
                        <div class="flex flex-row items-center py-4 group">
                          <div class="btn ml-3 draggable-handler mr-4 flex-shrink-0"></div>
                          <div
                            class="w-12 h-12 rounded bg-gray-600 overflow-hidden flex items-center justify-center flex-shrink-0">
                            <img :src="item.image" alt="BuildaBox Order Details Page" />
                          </div>
                          <div class="ml-4 min-w-0">
                            <div class="flex items-center">
                              <div class="font-semibold">
                                {{ item.name }}
                              </div>
                            </div>
                            <div class="text-gray-600 mt-1">{{ item.description }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else class="text-center text-gray-600 my-2 p-5"></div>
                  </div>
                </div>
              </div>
              <div class="p-6" v-else>
                <div class="text-center text-white opacity-30 p-4 bg-green-500">
                  No products and services available.
                </div>
              </div>
            </div>

            <!-- Territories table -->
            <div class="bg-white rounded-lg shadow-card mx-auto">
              <header class="flex flex-col md:flex-row justify-between px-6 py-4">
                <h2 class="font-semibold text-2xl lg:text-2xl py-2">
                  Territories
                </h2>
              </header>
              <div>
                <table class="table-fixed text-left w-full text-sm">
                  <thead 
                    v-if="locations && locations.length > 0"
                    class="hidden md:table-header-group"
                    >
                    <tr class="border-t border-b border-light-gray px-6 py-4">
                        <th class="px-6 py-3">
                        <span class="text-dark-gray font-normal">POSTAL CODE</span>
                        </th>
                        
                    </tr>
                  </thead>
                  <tbody v-if="locations && locations.length > 0">
                  <tr v-for="location in locations" :key="location.id" class="border-t border-light-gray">
                    <td class="block md:table-cell px-6 py-4 md:py-5">
                      <div class="md:hidden text-dark-gray mb-2">
                        POSTAL CODE
                      </div>
                      <div>{{ location.location }}</div>
                    </td>
                  </tr>
                  </tbody>

                  <tbody v-else-if="!loading">
                  <tr class="border-t border-light-gray">
                    <td class="px-6 py-4">
                      <div class="text-center text-white opacity-30 p-4 bg-green-500">
                        No Territories available.
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>


          <!-- Right Panel -->
          <div class="col-span-12 lg:col-span-4 xl:col-span-3">
            <div class="bg-white rounded-lg shadow-card mx-auto px-6 py-6 mb-6">
              <h1 class="font-semibold text-2xl lg:text-2xl mb-3">
                {{ ep.name }}
              </h1>
              <div class="mb-8 relative">
                <img :src="ep.logo ? ep.logo : require('@/assets/images/image_unavailable.png')" :alt="ep.name">

              </div>
              <div class="ep-info mb-8">
                <div class="flex justify-between content-center">
                  <div class="text-lg font-semibold mb-2">Description</div>
                </div>
                <div class="text-sm">
                  {{ ep.description }}
                </div>
              </div>

              <div class="caterer-info mb-8">
                <div class="flex justify-between content-center">
                  <div class="text-lg font-semibold mb-2">Email</div>
                  
                </div>
                <div class="text-sm">
                  {{ ep.email }}
                </div>
              </div>

              <div class="ep-info mb-8">
                <div class="flex justify-between content-center">
                  <div class="text-lg font-semibold mb-2">Services</div>
                  
                </div>
                <div class="tags flex flex-wrap -m-1">
                  <span v-for="type in ep.services" :key="type.id" class="m-1">
                    {{ type.name }}
                  </span>
                </div>
              </div>
              <div class="ep-info mb-8">
                <div class="flex justify-between content-center">
                  <div class="text-lg font-semibold mb-2">Contact Person</div>
                
                </div>
                <div class="text-sm">
                  {{ ep.contact_first_name }} {{ ep.contact_last_name }}
                </div>
              </div>
              <div class="ep-info mb-8">
                <div class="flex justify-between content-center">
                  <div class="text-lg font-semibold mb-2">Address</div>
                  
                </div>
                <div class="text-sm">
                  {{ ep.address }}
                </div>
              </div>
              <div class="ep-info mb-8">
                <div class="flex justify-between content-center">
                  <div class="text-lg font-semibold mb-2">State</div>
                  
                </div>
                <div class="text-sm">
                  {{ ep.state }}
                </div>
              </div>
              <div class="ep-info mb-8">
                <div class="flex justify-between content-center">
                  <div class="text-lg font-semibold mb-2">Zip</div>
                  
                </div>
                <div class="text-sm">
                  {{ ep.zip }}
                </div>
              </div>
              <div class="ep-info">
                <div class="flex justify-between content-center">
                  <div class="text-lg font-semibold mb-2">Phone</div>
                  
                </div>
                <div class="text-sm">
                  {{ ep.phone }}
                </div>
              </div>
            </div>

          
          </div>
        </div>

      </div>
    </section>
  </DefaultBackground>
</template>

<script>
import DefaultBackground from "@/components/common/layout/DefaultBackground";
import Api from "@/api/api_v1.0"

export default {
  name: "EventPlannerDashboard",

  components: {
    DefaultBackground
  },

  data() {
    return {
      loading: true,
      ep: null,
      categories: [],
      locations: [],
    }
  },

  async created() {

    
    await this.getEPInfo();

    await this.getCategories();
    await this.getLocationsPrice();
    
  },

  methods: {
    async getCategories() {
      const result = await Api.getEventPlannerCategories(this.ep.id);
      this.categories = result.data;
    },

    async getEPInfo() {
      const response = await Api.getEvplannerBySlug(this.$route.params.slug);
      this.ep = response.data;
      
      this.loading = false
    },

    async getLocationsPrice() {
      try {
        const response = await Api.getEventPlannerLocationsPrice({
          locations: this.ep.service_zip_codes.map(zip => zip.text),
          event_planner_id: this.ep.id
        });

        this.locations = response.data.prices;
      } catch (e) {
        console.error(e)
      }
    },

  },

  computed: {
    canMakeOrder() {
      return this.ep.status == 'active';
    }
  }
}
</script>
